import React, { useContext, useEffect, useState } from 'react';
import store from '../../../../redux/store';
import { useNavigate } from 'react-router-dom';
import { AlertContext, Alert_, CardsForty, CardsSixty, Google_Search, Grey_Link, On_Click_Card, PageAlwaysVisible, PageDesktopOnly, PageDesktopPadding, PageIllu, PageSixty, PageSubtitle, PageTitle, Section_Search, Sixty_Card_Loader } from 'monica-alexandria';
import { Helmet } from 'react-helmet';
import i18n from '../../../../localization/i18next';
import { t } from 'i18next';
import { AuthContext } from '../../../../services/authentication/Guard';
import { checkOwnership } from '../../../../helpers/verifyToolOwnership';
import { SearchWrapper } from './ACCOUNTS.css';
import GoogleCover from '../../../../assets/googleNetwork/googleCover.png';
import { get_accounts } from '../../../../services/api/Accounts';

const environment = process.env.REACT_APP_SERVER;

export default function ACCOUNTS() {

    const lang = i18n.language ? i18n.language : 'en';
    const navigate = useNavigate();
    const auth = useContext(AuthContext);
    const userId = auth?.user?.sub;

    /* For tool ownership validation */
    const [hasCheckOwnership, setHasCheckOwnership] = useState(false);

    /* Search */ 
    const [searchResults, setSearchResults] = useState([]);
    const [displayedResults, setDisplayedResults] = useState([]);

    const [accounts, setAccounts] = useState([]);

    /* Alerts */ 
    const { alerts, setAlerts } = useContext(AlertContext);

    const alertMessage = (message, status) => {
        setAlerts([
            ...alerts,
            {
                message: {
                    text: message,
                    status: status,
                },
            },
        ]);
    };


    const handleNavigation = (route) => {
        navigate(`/${lang}/${route}`);
    };


    const handleSelection = (account) => {
        store.dispatch({type: "SAVE_GOOGLE_CLIENT_ACCOUNT", payload: {name: account?.title}})
        navigate(`/${lang}/google/reports`);
    }

    /* Switch data assignment ( Real/Dummy ) */
    const initActions = () => {
        get_accounts(userId, "google")
            .then((res) => {
                console.log('res',res);
                if ( res.data?.data ) {
                    setAccounts(res.data?.data)
                    setDisplayedResults(res.data?.data)
                }
            }).catch(err => {console.error(err); alertMessage("Something went wrong", "Error")})
    }


    useEffect(() => {
        if ( searchResults.input ) setDisplayedResults(searchResults.data);
        else setDisplayedResults(accounts);
    },[searchResults])

    useEffect(() => {
        initActions();
    },[])

    /* Validate Tool Ownership */
    useEffect(() => {
        if (userId) checkOwnership(userId, navigate, lang, setHasCheckOwnership);
    }, [userId]);


    return (
        <>
        <Helmet>
            <title>Adsnap | Accounts</title>
        </Helmet>
        <Alert_ messages={alerts} />
            {hasCheckOwnership && (
                <PageSixty>
                    <PageAlwaysVisible>
                        <PageTitle>
                            <h1>{t('My Accounts')}</h1>
                        </PageTitle>

                        {accounts.length > 9 ? (
                            <SearchWrapper>
                                <Google_Search
                                    file={accounts}
                                    fileKeys={['name', 'name_reversed', 'id']}
                                    defaultValue={''}
                                    sanitize={true}
                                    placeholder={t('Search account')}
                                    applyReverseFileProperties={[
                                        {
                                            originalKey: 'name',
                                            reversedKey: 'name_reversed',
                                        },
                                    ]}
                                    setResults={(data) => setSearchResults(data)}
                                    debounceTime={750}
                                    minMatchCharacters={1}
                                    maxMatchCharacters={50}
                                    disabled={false}
                                    isCaseSensitive={false}
                                    maxAcceptedScore={0.6}
                                />
                            </SearchWrapper>
                        ) : null}

                        <CardsSixty>
                            {displayedResults.length > 0 &&
                                displayedResults.map((account) => {
                                    return <On_Click_Card 
                                        id={"AdSnap_Google_Accounts_1"}
                                        onClick={() => handleSelection(account)} 
                                        img={GoogleCover} 
                                        title={account.title}    
                                        subtitle={account.id} 
                                    />;
                                })}
                        </CardsSixty>

                    </PageAlwaysVisible>
                    <PageAlwaysVisible>
                        <PageDesktopPadding>
                            <CardsForty>
                                <On_Click_Card 
                                    icon="AddPlan" 
                                    title={t('New report')} 
                                    id={"AdSnap_Google_Accounts_2"} 
                                    onClick={() => handleNavigation(environment === 'LOCAL' ? 'google/source-account' : 'google/connect')} 
                                />
                            </CardsForty>
                        </PageDesktopPadding>
                    </PageAlwaysVisible>
                </PageSixty>
            )}
        </>
    );
}